var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"bem",rawName:"v-bem"}],style:({
    '--x': (_vm.x + "px"),
    '--y': (_vm.y + "px")
})},[_c('v-icon',{attrs:{"solid":"","icon":"exclamation","size":"sm","container-size":"xs"}}),_c('strong',{directives:[{name:"bem",rawName:"v-bem:field",arg:"field"}]},[_vm._t("field")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }